import moment from "moment";
import BaseModelPartner from "@/models/BaseModelPartner.js";
import BaseModelVestingSchedule from "@/models/BaseModelVestingSchedule.js"; 
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";

import VestingScheduleDatesMixin from "@/mixins/VestingScheduleDatesMixin.js";

import {
  mapActions,
  mapState,
  mapGetters
} from 'vuex';

export default {
    name: "VestingMixin",
    data: function() {
      return {
        BaseModelVestingSchedule:BaseModelVestingSchedule,
        partnerLeaveDate:""
      }
    },
    mixins: [apiUtil, funcUtil,VestingScheduleDatesMixin],
    computed: {
      ...mapState("postModule", ["response"]),
      ...mapGetters("getModule", ["getAllItemFilter","withFilter", "getAll","getLocalInputControls"])
  },
    methods: {  
      _getVestingFromTransactions(TransactionModel,TransactionQuery,OutPutArray,inputDate){
        const self=this;
        let TransactionData=this.withFilter(TransactionModel.list,TransactionQuery)
        TransactionData.forEach(element => {
          let obj={}
          obj.ProgramId=element.ProgramId
          obj.ProgramTitle=element.ProgramTitle
          obj.ReceiverId=element.ReceiverId
          obj.ReceiverFullName=element.ReceiverFullName
          obj.SenderId=element.SenderId
          obj.SenderFullName=element.SenderFullName
          obj.UnitClass=element.UnitClass
          obj.UnitType=element.UnitType
          obj.VestingType=element.VestingType
          obj.UnitPool=element.UnitPool
          obj.Unit=element.Unit
          obj.BusinessEvent="Vesting"
          obj.Status=element.Status
          obj.WorkflowStatus=element.WorkflowStatus
          obj.VestStartDate=element.VestStartDate
          
          if (!self.IsAcceleratedVesting(element.ReceiverId,element.VestYear4Date)) {
            if (element.VestingType=="Standard") {
              let vestStartDate = moment(element.VestStartDate);
              let dateToCompare = moment(inputDate);
              let yearDiff=dateToCompare.diff(vestStartDate, 'years');
              
              switch (true) {
                case (yearDiff<1):
                  obj.Percentage=0;
                  obj.Year = 0;
                  obj.VestedUnit=obj.Percentage * obj.Unit;
                  obj.VestedDate= element.VestStartDate;
                  obj.NextVestedDate = moment(element.VestYear1Date).format('MM/DD/YYYY');
                  obj.InitialVesting = moment(element.VestStartDate).format('MM/DD/YYYY');
                  obj.UnitGranted = obj.Unit;
                  break;
                case (yearDiff==1):
                  obj.Percentage=0.25;
                  obj.Year = 1;
                  obj.VestedUnit=obj.Percentage * obj.Unit;
                  obj.VestedDate= element.VestYear1Date;
                  obj.NextVestedDate = moment(element.VestYear2Date).format('MM/DD/YYYY');
                  obj.InitialVesting = moment(element.VestStartDate).format('MM/DD/YYYY');
                  obj.UnitGranted = obj.Unit;
                  break;
                case (yearDiff==2):
                  obj.Percentage=0.5;
                  obj.Year = 2;
                  obj.VestedUnit=obj.Percentage * obj.Unit;
                  obj.VestedDate= element.VestYear2Date;
                  obj.NextVestedDate = moment(element.VestYear3Date).format('MM/DD/YYYY');
                  obj.InitialVesting = moment(element.VestStartDate).format('MM/DD/YYYY');
                  obj.UnitGranted = obj.Unit;
                  break;
                case (yearDiff==3):
                  obj.Percentage=0.75;
                  obj.Year = 3;
                  obj.VestedUnit=obj.Percentage * obj.Unit;
                  obj.VestedDate= element.VestYear3Date;
                  obj.NextVestedDate = moment(element.VestYear4Date).format('MM/DD/YYYY');
                  obj.InitialVesting = moment(element.VestStartDate).format('MM/DD/YYYY');
                  obj.UnitGranted = obj.Unit;
                  break;
                case (yearDiff>=4):
                  obj.Percentage=1;
                  obj.Year = 4;
                  obj.VestedUnit=obj.Percentage * obj.Unit;
                  obj.VestedDate= element.VestYear4Date;
                  obj.NextVestedDate = 'N/A';
                  obj.InitialVesting = moment(element.VestStartDate).format('MM/DD/YYYY');
                  obj.UnitGranted = obj.Unit;
                  break;    
                default:
                  return
                  break;
              }
            }else if(element.VestingType=="Cliff" ){

              if(element.VestCliffDate == '1900-01-01T05:00:00')
              {
                //Vesting Schedule Date Changes
                /*
                let VestingScheduleResponse=self.withFilter(self.BaseModelVestingSchedule.list,{filter: "Program/Id eq " + element.ProgramId +" and UnitClass eq "+"'"+element.UnitClass +"'"
                +" and UnitType eq "+"'"+element.UnitType +"'"
                +" and VestingType eq "+"'"+element.VestingType +"'"})
                */

                let VestingScheduleResponse = this.getAll(BaseModelVestingSchedule.list)
                                .filter(vestingschedule=>vestingschedule.ProgramId == element.ProgramId 
                                  && vestingschedule.UnitClass == element.UnitClass
                                  && vestingschedule.UnitType == element.UnitType
                                  && vestingschedule.VestingType == element.VestingType
                                  );
                            
                self._getVestingDates(obj,VestingScheduleResponse);
                element.VestCliffDate = obj.VestCliffDate;
              }

              let cliffDate = moment(element.VestCliffDate).unix();
              obj.VestStartDate=element.VestCliffDate

              if(cliffDate > 0 && moment(element.VestCliffDate)<= moment(inputDate)) {
                obj.Percentage=1;
                obj.Year = 1;
                obj.VestedUnit=obj.Percentage * obj.Unit;
                obj.VestedDate= element.VestCliffDate;
                obj.NextVestedDate = 'N/A';
                obj.InitialVesting = moment(element.VestStartDate).format('MM/DD/YYYY');
                obj.UnitGranted = obj.Unit;
              } else {
                obj.Percentage=0;
                obj.VestedUnit=obj.Percentage * obj.Unit;
                obj.VestedDate= moment(element.VestCliffDate)<= moment(inputDate) ? element.VestCliffDate : "";
                obj.NextVestedDate = obj.VestedDate == '' ? 'N/A' : moment(element.VestCliffDate).format('MM/DD/YYYY');
                obj.InitialVesting = moment(element.VestStartDate).format('MM/DD/YYYY');
                obj.UnitGranted = obj.Unit;
              }
            }
          }
        //This is for Accelerated VEsting for Retired Employee : Vest 100%
          else{
          // Check if cliff is null for 0%
          // if(element.VestingType=="Cliff" ) {
          //   let cliffDate = moment(element.VestCliffDate).unix();
          //   if(cliffDate < 0) {
          //     obj.Percentage=0;
          //     obj.VestedUnit=obj.Percentage * obj.Unit;
          //   } else {
          //     obj.Percentage=1;
          //     obj.VestedUnit=obj.Percentage * obj.Unit;
          //   }
          // }

          // if (moment(self.partnerLeaveDate)<=moment(element.VestYear4Date)) {
          //   obj.SpecialArrangement="Retirement Acceleration";
          //   obj.VestedDate=self.partnerLeaveDate;
          // } else{
          //   obj.SpecialArrangement="";
          //   obj.VestedDate=element.VestYear4Date;
          // }
          if(element.VestingType=="Cliff") {
            let cliffDate = moment(element.VestCliffDate).unix();
            obj.VestStartDate=element.VestCliffDate
            if(cliffDate < 0) {
              console.log("null",element);
              obj.Percentage = 0;
              obj.VestedUnit = 0;
              obj.NextVestedDate = 'N/A';
              obj.InitialVesting = moment(element.VestStartDate).format('MM/DD/YYYY');
              obj.UnitGranted = obj.Unit;
            } else {
              obj.Percentage = 1;
              obj.Year = 1;
              obj.VestedUnit=obj.Percentage * obj.Unit;
              obj.NextVestedDate = 'N/A';
              obj.InitialVesting = moment(element.VestStartDate).format('MM/DD/YYYY');
              obj.UnitGranted = obj.Unit;
            }
          } else {
            obj.Percentage=1;
            obj.Year = 1;
            obj.VestedUnit=obj.Percentage * obj.Unit;
            obj.NextVestedDate = 'N/A';
            obj.InitialVesting = moment(element.VestStartDate).format('MM/DD/YYYY');
            obj.UnitGranted = obj.Unit;
          }

          if (moment(self.partnerLeaveDate)<=moment(element.VestYear4Date)) {
            obj.SpecialArrangement="Retirement Acceleration";
            obj.VestedDate=self.partnerLeaveDate;
            obj.NextVestedDate = 'N/A';
            obj.InitialVesting = moment(element.VestStartDate).format('MM/DD/YYYY');
            obj.UnitGranted = obj.Unit;
          } else{
            obj.SpecialArrangement="";
            obj.VestedDate=element.VestYear4Date;
            obj.NextVestedDate = 'N/A';
            obj.InitialVesting = moment(element.VestStartDate).format('MM/DD/YYYY');
            obj.UnitGranted = obj.Unit;
          }
        }
        
        if(Number.isNaN(obj.Percentage)){
          console.log("NaN mixin", console.log(obj));
        }
          OutPutArray.push(obj);
        });      
      },
      IsAcceleratedVesting(partnerId,vestYear4Date){
        let query = {
          batchQuery: true,
          filter: function(o) {
            // let isNullDate = Number.isNaN(Date.parse((o.LeaveDate)));
            // if(isNullDate) {
            //   //console.log("Null Date",JSON.stringify(o));
            //   return (
            //     o.Id == partnerId &&
            //     ( o.PartnerStatus === "Retired Employee" ||
            //       o.PartnerStatus === "Retired Family Member"
            //     )
            //   )
            // } else {
              return (
                o.Id && o.Id == partnerId &&
                ( //o.StartBuyout == "Completed" ||  
                o.PartnerStatus === "Retired Employee" ||
                  o.PartnerStatus === "Retired Family Member" 
                )
              );
            //}

          }
        };
        let partnerResult=this.withFilter(BaseModelPartner.list,query)
        // if(partnerResult[0].LeaveDate === "" && 
        //   (partnerResult[0].PartnerStatus === "Retired Employee" ||
        //   partnerResult[0].PartnerStatus === "Retired Family Member")
        // ) {
        //     return true;
        // }
        if (partnerResult && partnerResult.length>0) {
        // if(partnerResult[0].LeaveDate === "" && 
        //   (partnerResult[0].PartnerStatus === "Retired Employee" ||
        //   partnerResult[0].PartnerStatus === "Retired Family Member")
        // ) {
        //   console.log("partnerResult[0]",partnerResult[0]);
        //     return true;
        // }          
          this.partnerLeaveDate=partnerResult[0].LeaveDate;
          return true;
        } else {
          return false;
        }
      }     
    }
}